import { EmpresaProps } from './useConfiguracionEmpresa';

/**
 * Marca del origen a partir del bootstrap del cotizador (`parametros.origen` y `estilos`), con la
 * misma regla que aplicaba `Pages/Auto/Cotizador.tsx`. Devuelve los dos argumentos de `setConfig`.
 */
export const configEmpresaDeParametros = (parametros: { origen: string; estilos?: string | null }): [EmpresaProps, string] => {
  const origen = parametros.origen.includes('SEGURARSE') ? 'SEGURARSE' : parametros.origen;
  if (parametros.estilos) return [{ ...JSON.parse(parametros.estilos), origen }, origen];
  return [
    {
      origen,
      images: { logo: '' },
      colors: { accent: '', primary: '', secondary: '', tertiary: '', icons: '', navbar: '', segu_stepper: '' },
      config: { cookies: true },
    },
    origen,
  ];
};
